import { format } from 'date-fns';

export const formatDateShortDayName = (date?: string | Date) => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return date ? format(date, 'dd E') : null;
};

export const formatDate = (date?: string | Date) => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return date ? format(date, 'dd.MM.yyyy') : null;
};

export const formatDateTime = (date?: string | Date) => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return date ? format(date, 'dd.MM.yyyy HH:mm:ss') : null;
};

export const toDate = (date: string | Date) => {
  if (typeof date === 'string') {
    return new Date(date);
  }
  return date;
};
